import { message } from 'antd';
import { fetchWithoutToken } from '../helpers/fetch.js';
import {types} from '../types/types.js';
import { loading } from './uiActions.js';
import jwt_decode from "jwt-decode";
import Cookies from "universal-cookie";
import { useNavigate } from 'react-router-dom';

const cookies = new Cookies();
  

export const login = (credentials) => {
   
    return async(dispatch) => {

        console.log('Credenciales de Usuario');
        console.log(credentials);
        
        dispatch(loading(true))

        try{
            const req = await fetchWithoutToken('authorize', credentials, 'POST')
            const res = await req.json();

            

            if(res.token || res.accessToken){
                 
                
                // localStorage.setItem('token', res.accessToken)
                cookies.set("token", (res.token == null || res.token == undefined)? res.accessToken : res.token, { path: "/" });
                dispatch(loading(false))
    
                const decoded = jwt_decode((res.token == null || res.token == undefined)? res.accessToken : res.token);
                dispatch(setPermissions(decoded.permissions))
                dispatch(setRealm(decoded.realm))
                dispatch(setUsername(decoded.Name))
                dispatch(setBusinessName(decoded.customer_name))
 

                window.location.href = '/';
                
            }else {
                dispatch(loading(false))
                message.error('Credenciales inválidas, favor verificar usuario o contraseña')
            }
        }
        catch(err){
            message.error('Credenciales inválidas, favor verificar usuario o contraseña')
            dispatch(loading(false))
        }
    }
}

export const setUsername = (name) => ({
    type: types.setUsername,
    payload: name
})

export const setPermissions = (value) => ({
 type: types.setPermissions,
 payload: value   
});

export const setRealm = (value) => ({
 type: types.setRealm,
 payload: value   
});

export const setBusinessName = (value) => ({
 type: types.setBusinessName,
 payload: value   
});


export const startLogout = () => {
    return (dispatch) => {
        // Eliminar cookies o tokens
        cookies.remove("token", { path: "/" });

        // Limpiar estado global
        dispatch({ type: 'LOGOUT_USER' });

        // Redirigir al login
        window.location.href = '/login'; // Reemplaza history.push si estás fuera de componente
    };
};